.input {
    margin-bottom: var(--mantine-spacing-xs);
    border-radius: 0 var(--mantine-radius-md) var(--mantine-radius-md) 0;
}

.wrapper {
    flex: 1;
}
